import { getUserInfoRequest } from '@/api/login'

const user: any = {
  token: '',
  userName: '',
  custRegionCode: '',
  userId: '',
  roleNumber: '',
}

const mutations: any = {
  SET_TOKEN: (state: any, token: any) => {
    state.token = token
  },
  SET_USERNAME: (state: any, userName: any) => {
    state.userName = userName
  },
  SET_REGIONCODE: (state: any, custRegionCode: any) => {
    state.custRegionCode = custRegionCode
  },
  SET_USERID: (state: any, userId: any) => {
    state.userId = userId
  },
  SET_ROLENUMBER: (state: any, roleNumber: any) => {
    state.roleNumber = roleNumber
  }
}

const actions: any = {
  // 获取用户信息
  GetUserInfo({ commit }: any) {
    return new Promise((resolve, reject) => {
      getUserInfoRequest().then(response => {
        if (response.status === 0) {
          const result = response.data
          commit('SET_REGIONCODE', result.custRegionCode)
          commit('SET_USERNAME', result.userName)
          commit('SET_USERID', result.userId)
          commit('SET_ROLENUMBER', result.roleNumber)
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  user,
  mutations,
  actions,
}
